'use client';

import Lottie from 'lottie-react';

import countdown from './countdown.json';

export function CountDown() {
  return (
    <Lottie
      animationData={countdown}
      loop={false}
      autoplay={true}
      style={{
        height: '30%',
      }}
    />
  );
}
